export const debounce = <T extends (...args: any[]) => void>(
  func: T,
  delay: number
): ((...args: Parameters<T>) => void) => {
  let timeoutId: ReturnType<typeof setTimeout>;
  return (...args: Parameters<T>) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};


export const extractDomain = (): string => {
  if (typeof window === "undefined") return "";

  const currentOrigin = window.location.origin;

  if (
    currentOrigin.includes("localhost:3000") ||
    currentOrigin.includes("test")
  ) {
    return "https://recruiter.foundit.in";
  }

  return currentOrigin;
};